import { c as _c } from "react/compiler-runtime";
import { useBuilder } from '../store/provider';
export const useNormsSave = () => {
  const $ = _c(5);
  const {
    state,
    mutateOp
  } = useBuilder();
  let t0;
  if ($[0] !== mutateOp || $[1] !== state.bundle || $[2] !== state.current?.isHistoricalPreview || $[3] !== state.savedBundle) {
    t0 = () => {
      if (state.current?.isHistoricalPreview) {
        return;
      }
      if (!state.savedBundle) {
        return;
      }
      if (state.bundle.norms === state.savedBundle.norms) {
        return;
      }
      mutateOp({
        kind: "update_norms",
        norms: state.bundle.norms
      });
    };
    $[0] = mutateOp;
    $[1] = state.bundle;
    $[2] = state.current?.isHistoricalPreview;
    $[3] = state.savedBundle;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};